export const getBlockConfigAndLockdata = (block, data) => {
  let config;
  let lockData = null;
  const newData = JSON.parse(JSON.stringify(data));

  switch (block) {
    case "detailsview":
      config = newData.detailsView;
      lockData = newData.lockData;
      break;
    case "recordsview":
      config = newData.recordsView;
      lockData = newData.lockData;
      break;
    case "chart":
      config = newData.chart;
      lockData = newData.lockData;
      break;
    case "progress-bar":
      config = newData.progressBarConfig;
      lockData = newData.lockData;
      break;
    default:
      config = newData;
      break;
  }

  return {
    config,
    lockData
  };
};
